import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modals/password';
import {changePassword} from '../../../reducers/user/actions';
import MaskedInput from 'react-text-mask';
import ModalsUtil from '../../../utils/modals';
import Language from '../../../language';

export default () => {
    const {user, changePasswordButton} = useSelector(Selector), 
          dispatch = useDispatch();

    const [state, setState] = useState({
        data: {
            old_password: "",
            new_password: "",
            repeat_password: ""
        }
    });

    const changeHandler = e => {
        setState({
            data: {
                old_password: "",
                new_password: "",
                repeat_password: ""
            }
        });

        const [old, newp, repeat] = [
            document.getElementById('password-old'),
            document.getElementById('password-new'),
            document.getElementById('password-repeat'),
        ];

        if(old) old.value = "";
        if(newp) newp.value = "";
        if(repeat) repeat.value = "";

        setTimeout(() => {
            ModalsUtil.close();
        }, 300);
    }

    useEffect(() => {
        document.addEventListener('password.changed', changeHandler);
        return () => document.removeEventListener('password.changed', changeHandler);
    }, []);

    return (
        <div className="modal modal-password animate__zoomIn animate__animated" data-target="password" style={{display: 'none'}}>
            <div className="modal-close" onClick={e => ModalsUtil.close()}></div>
            <div className="title">{Language('modals.password.title')}</div>
            <div className="inputs">
                <div className="input">
                    <MaskedInput 
                        type="password"
                        id="password-old"
                        mask={[
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                        ]}
                        guide={false}
                        placeholder={Language('modals.password.old_password')} 
                        spellCheck="false" 
                        autoCorrect="false" 
                        autoCapitalize="off" 
                        autoComplete="false" 
                        inputMode="numeric"
                        defaultValue={state.data.old_password}
                        autoFocus
                        onChange={e => setState({
                            ...state,
                            data: {
                                ...state.data,
                                old_password: e.target.value
                            }
                        })} />
                </div>

                <div className="input">
                    <MaskedInput 
                        type="password"
                        id="password-new"
                        mask={[
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                        ]}
                        guide={false}
                        placeholder={Language('modals.password.new_password')} 
                        spellCheck="false" 
                        autoCorrect="false" 
                        autoCapitalize="off" 
                        autoComplete="false" 
                        inputMode="numeric"
                        defaultValue={state.data.new_password}
                        autoFocus
                        onChange={e => setState({
                            ...state,
                            data: {
                                ...state.data,
                                new_password: e.target.value
                            }
                        })} />
                </div>

                <div className="input">
                    <MaskedInput 
                        type="password"
                        id="password-repeat"
                        mask={[
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                            /[0-9]/,
                        ]}
                        guide={false}
                        placeholder={Language('modals.password.repeat_password')} 
                        spellCheck="false" 
                        autoCorrect="false" 
                        autoCapitalize="off" 
                        autoComplete="false" 
                        inputMode="numeric"
                        defaultValue={state.data.repeat_password}
                        autoFocus
                        onChange={e => setState({
                            ...state,
                            data: {
                                ...state.data,
                                repeat_password: e.target.value
                            }
                        })} />
                </div>
            </div>

            <div className="button" onClick={e => {
                if(!changePasswordButton)
                    dispatch(changePassword(state.data));
            }}>{Language('modals.password.button')}</div>
        </div>
    )
}